import { Component, Inject, OnInit } from '@angular/core';
import { ApiRequestService } from '../../shared/api-request-service';
import { MyOrdersRequest } from './myordersrequest';
import { Order } from './order.model';
import { MyOrdersResponse } from './myordersresponse';
import { OrderProduct } from './order-product.model';
import { GetProductRequest } from './get-product-request';
import { GetProductResponse } from './get-product-response';
import { Product } from './product.model';
import { Router } from '@angular/router';
import { GetOrderedStoreProductsRequest } from './getorderedstoreproductsrequest';
import { GetOrderedStoreProductsResponse } from './getorderedstoreproductsresponse';
import { StoreOrderedProduct } from './storeorderproduct';

@Component({
    selector: 'pw-myorders',
    templateUrl: './myorders.component.html',
    styleUrls: ['./myorders.component.scss']
})
export class MyordersComponent implements OnInit {
    deliveryFee = 1140;

    myOrdersUrl = '/client/myorders';

    orderBackendUrl = '';

    orderList: Order[] = [];

    getProductRequest: GetProductRequest = {};

    productList: Product[] = [];

    GET_ORDEREDPRODUCTS_URI = '/client/get-orderedproducts';

    GET_ORDERED_STOREPRODUCTS_URI = '/client/get-ordered-storeproducts';

    storeBackendUrl = '';

    isProductScreenVisible = false;

    deliveryOption = '';

    totalPrice = 0;

    preOrder = false;

    getOrderedStoreProductsRequest: GetOrderedStoreProductsRequest = {};

    getOrderedStoreProductsResponse: GetOrderedStoreProductsResponse = {};

    storeOrderedProductsList: StoreOrderedProduct[] = [];

    orderProductListForrequest: OrderProduct[] = [];

    constructor(
        @Inject('STORE_BACKEND_URL') private _storeBackendUrl: string,
        private _apiRequestService: ApiRequestService,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string,
        private _router: Router
    ) {
        this.orderBackendUrl = _orderBackendUrl;
        this.storeBackendUrl = _storeBackendUrl;
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            const myOrdersRequest: MyOrdersRequest = {
                clientId: JSON.parse(sessionStorage.getItem('clientId') as string)
            };
            this._apiRequestService
                .sendRequest(this.orderBackendUrl, true, myOrdersRequest, true, this.myOrdersUrl)
                .subscribe((answer) => {
                    const response = answer as MyOrdersResponse;
                    this.orderList = response.orderList as Order[];
                    this.orderList.forEach((order) => {
                        const date = order.insertedTimestamp?.toString();
                        const splittedDate = date?.split(',');
                        order.insertedTimestampp = splittedDate![0] + '.' + splittedDate![1] + '.' + splittedDate![2];
                    });
                });
        }
        else {
            this._router.navigateByUrl('/');
        }
    }

    getProducts(order: Order) {
        order.orderProductList?.forEach((orderProduct => {
            const orderProductElement: OrderProduct = {
                productId: orderProduct.productId,
                quantity: orderProduct.quantity,
                packageName: orderProduct.packageName,
                price: orderProduct.price,
                isPreorder: orderProduct.isPreorder,
                available: orderProduct.available
            }
            this.orderProductListForrequest.push(orderProductElement);
        }))
        this.getOrderedStoreProductsRequest = {
            orderProductList: this.orderProductListForrequest
        };

        this._apiRequestService
            .sendRequest<GetOrderedStoreProductsRequest, GetOrderedStoreProductsResponse>(
                this.storeBackendUrl,
                true,
                this.getOrderedStoreProductsRequest,
                true,
                this.GET_ORDERED_STOREPRODUCTS_URI
            )
            .subscribe((response: GetOrderedStoreProductsResponse) => {
                this.storeOrderedProductsList = response.storeOrderedProductList as StoreOrderedProduct[];
                this.isProductScreenVisible = true;
                this.totalPrice = order.totalPrice!;
            });
        this.isProductScreenVisible = true;
        this.preOrder = order.preOrder as boolean;
    }

    backToOrders() {
        this.isProductScreenVisible = false;
    }
}
